import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["rate", "confirmedRates", "batchUpdateSelected"];

  initialize() {
    this.rateId = this.element.dataset.rateId;
    this.setConfirmedRates([], true);
    this.vesselRates = null;
  }

  // array is an expected argument
  setConfirmedRates(value, initial) {
    if (value.length) {
      this.confirmedRatesTarget.value = JSON.stringify(value);
      this.batchUpdateSelectedTarget.value = true;
    } else {
      this.confirmedRatesTarget.value = null;
      if (!initial) {
        this.batchUpdateSelectedTarget.value = false;
      }
    }
    this.confirmedRates = value;
    this.setPreviewNote();
  }

  setPreviewNote() {
    let note = "";
    if (this.confirmedRates.length) {
      const titles = this.confirmedRates.map(
        (rateId) => (this.vesselRates.find((rate) => rate.id == rateId) || {}).shipment_title
      );
      note = `Update action will also affect shipments ${titles.join(
        ", "
      )} Click on update button to complete`;
    }

    this.element.querySelector(".preview-note").textContent = note;
  }

  connect() {
    document.body.addEventListener(
      `cortana:rates-confirmed-${this.rateId}`,
      this.confirmed.bind(this)
    );
    document.body.addEventListener(
      `cortana:rates-cancelled-${this.rateId}`,
      this.cancelled.bind(this)
    );
  }

  changed(e) {
    if (this.batchUpdateSelectedTarget.value == false) {
      e.preventDefault();
      this.getSimillarVesselExchangeRates(this.rateId, (data) => {
        this.vesselRates = data;
        this.showPopover();
      });
    }
  }

  getSimillarVesselExchangeRates(rateId, callback) {
    $.getJSON(`/admin/saved_exchanges/${rateId}/associated_vessel_exchange_rates`, (data) => {
      callback(data);
    });
  }

  hidePopover() {
    $(".popover").popover("hide");
  }

  preventPopoverEvent(e) {
    e.preventDefault();
  }

  showPopover() {
    if (!this.vesselRates.length) {
      console.log("No Vessel Rates");
      $(`#edit_saved_exchange_${this.rateId}`).submit();
      return;
    }
    $(this.rateTarget.parentElement).popover({
      title:
        "These other shipments are also on the same vessel, do you wish to adjust Vessel rate for them?",
      content: () => this.popoverContent(this.vesselRates),
      html: true,
      sanitize: false,
      trigger: "manual",
    });

    $(this.rateTarget.parentElement).popover("show");
  }

  popoverContent(allRates) {
    const selectedValues = this.confirmedRates.length
      ? this.confirmedRates
      : allRates.map((x) => x.id);
    return `<div class="shipment-legs-popover" data-vessel-rate-popover-rates-value="${JSON.stringify(
      selectedValues
    )}" data-vessel-rate-popover-saved-exchange-id-value="${
      this.rateId
    }" data-controller="vessel-rate-popover">
      <div class="popover-shipments">
        ${this.popoverShipments(allRates, selectedValues)}
      </div>
      <div class="popover-buttons">
        <button class="btn btn-primary btn-sm" data-action="vessel-rate-popover#confirm"> Include </button>
        <button class="btn btn-outline-secondary ml-1 btn-sm" data-vessel-rate-target="cancel" data-action="vessel-rate-popover#cancel"> Cancel </button>
      </div>
    </div>`;
  }

  popoverShipments(allRates, selectedValues) {
    console.log(allRates);
    return allRates
      .map(
        (rate) => `
      <div class="flex popover-shipment-item pt-1 pb-1 ${
        selectedValues.includes(rate.id) ? "selected" : ""
      }" data-rate-id="${rate.id}" data-action="click->vessel-rate-popover#change">
        <div>${rate.shipment_title}</div>
        <div> <i class="icon check"></i> </div>
      </div>
      `
      )
      .join("");
  }

  confirmed(e) {
    this.setConfirmedRates(e.detail.confirmedRates);
    this.hidePopover();
  }

  cancelled() {
    this.setConfirmedRates([]);
    this.hidePopover();
  }
}
